module.exports = __webpack_public_path__ + "static/media/support-1.edbd9fd2.svg";